import { createAsyncThunk } from '@reduxjs/toolkit';

import { PatientResponseDto, type AsyncThunkConfig } from 'types/types';
import { getPatientById } from 'api/controllers/patient-controller';

const getPatientData = createAsyncThunk<PatientResponseDto, string, AsyncThunkConfig>(
  'patient/getPatient',
  async (id) => {
    return await getPatientById(id);
  },
);

export { getPatientData };
